import React from 'react';
import '../style.css';
import {Form,Button,Container,Row,Col,Navbar,Nav,NavDropdown,FormControl} from 'react-bootstrap';
import * as FaIcons from 'react-icons/fa';
import * as FcIcons from 'react-icons/fc';


class Module2 extends React.Component {


    constructor(props) {
        super(props);
    }
    
    componentDidMount() { 
       
      }


      render() { 

        return (

            <>
             Rajib{this.props.par}
            </>
        );
      }




}

export default Module2;